export default {
  title: '供应商报价模板',
  standardTag: '系统标准',
  status: {
    enabled: '启用',
    disabled: '禁用',
    all: '全部'
  },
  templateTypes: {
    PREPORT: '港前',
    LASTMILES: '尾程',
    SEA: '海运',
    AIR: '空运',
    RAIL: '铁路',
    EXPRESS: '快递',
    FCL: '海运整箱',
    LCL: '海运拼箱',
    AIR_FCL: '空运整箱',
    AIR_LCL: '空运拼箱'
  },
  fieldTypes: {
    text: '文本',
    select: '下拉选择',
    date: '日期',
    number: '数字',
    fee: '费用',
    'fee-section': '费用表',
    'field-group': '字段组',
    'date-range': '日期范围',
    'suggest-multi': '多选(建议)',
    weekdays: '星期',
    suggest: '输入选择(单选)',
    checkbox: '复选框'
  },
  fieldTypesShort: {
    text: '文本',
    select: '下拉',
    date: '日期',
    number: '数字',
    fee: '费用',
    'fee-section': '费用表',
    'date-range': '日期范围',
    'suggest-multi': '多选',
    weekdays: '星期',
    suggest: '单选',
    checkbox: '复选'
  },
  common: {
    query: '查询',
    reset: '重置',
    save: '保存',
    cancel: '取消',
    back: '返回',
    edit: '编辑',
    detail: '详情',
    delete: '删除',
    retry: '重试',
    required: '必填',
    optional: '选填',
    visible: '显示',
    hidden: '隐藏',
    locked: '锁定',
    selected: '已选',
    loadFailed: '加载失败',
    saveFailed: '保存失败'
  },
  list: {
    create: '新建模板',
    keyword: '模板名称',
    keywordPlaceholder: '请输入模板名称/编号',
    templateType: '业务类型',
    status: '状态',
    noSupplierNeeded: '无需关联（默认兜底）',
    goAssociate: '去关联',
    associateSuppliers: '关联供应商',
    deleteConfirm: '确认删除此模板？删除后将自动解除关联供应商，且不可恢复。',
    empty: '暂无模板',
    columns: {
      templateNo: '模板编号',
      templateName: '模板名称',
      templateType: '业务类型',
      fieldCount: '字段数',
      suppliers: '关联供应商',
      status: '状态',
      updatedAt: '更新时间',
      actions: '操作'
    },
    messages: {
      enabled: '已启用',
      disabled: '已禁用',
      deleted: '已删除',
      standardCannotDelete: '系统标准模板不可删除'
    },
    confirm: {
      enable: '确定启用此模板？',
      disableStandard: '禁用后，所有未关联自定义模板的供应商将无法使用标准模板报价，确定禁用？',
      disableWithSuppliers: '该模板已关联 {count} 家供应商，禁用后这些供应商将无法使用此模板报价，确定禁用？',
      disable: '确定禁用此模板？'
    }
  },
  create: {
    back: '返回',
    editTitle: '编辑报价模板',
    createTitle: '新建报价模板',
    save: '保存',
    cancel: '取消',
    previewTitle: '报价表单预览',
    sharedFields: '公共字段',
    previewEmpty: '选择业务类型与模板配置后预览',
    basicInfo: '基本信息',
    templateName: '模板名称',
    templateNameRequired: '请输入模板名称',
    templateNamePlaceholder: '请输入模板名称，如：深圳港出口整箱报价',
    templateNo: '模板编号',
    autoGenerate: '自动生成',
    statusRequired: '请选择状态',
    businessTypeTitle: '业务类型',
    businessTypeRequired: '请选择业务类型',
    businessTypeImmutable: '业务类型创建后不可修改',
    modulesTitle: '模板配置（可选）',
    modulesRequired: '请至少勾选一个模板配置',
    modulesHint: '根据业务类型联动可选模块，默认全选',
    typesTitle: '模板类型',
    typesTitleMulti: '模板类型（可多选）',
    typesRequired: '请选择至少一个模板类型',
    selectedPrefix: '已选：',
    selectType: '请选择业务类型',
    selectModules: '请勾选模板配置',
    standardTypeLocked: '标准模板类型不可修改',
    typeImmutable: '模板类型创建后不可修改',
    selected: '已选',
    fieldConfig: '字段配置',
    fieldConfigTip: '使用箭头调整字段排序，开关控制必填/选填和显示/隐藏。锁定字段不可修改。',
    selectTypeFirst: '请先选择业务类型并勾选模板配置',
    keepOneType: '至少保留一个模板配置',
    changeBusinessTitle: '切换业务类型',
    changeBusinessContent: '切换业务类型将重置模板配置与字段，确定继续？',
    unselectTypeTitle: '取消模板配置',
    unselectTypeContent: '取消「{typeLabel}」将清除该模块字段配置，确定继续？',
    loadDefaultFieldsFailed: '加载默认字段失败',
    templateNotFound: '模板不存在',
    selectAtLeastOneType: '请至少勾选一个模板配置',
    updated: '模板已更新',
    created: '模板已创建',
    leaveTitle: '确认离开',
    leaveContent: '当前填写内容将丢失，确定离开？'
  },
  detail: {
    back: '返回模板列表',
    title: '模板详情：{templateName}',
    loading: '加载模板详情...',
    loadFailed: '加载失败',
    retry: '重试',
    basicInfo: '基本信息',
    systemLocked: '系统锁定',
    custom: '自定义',
    requiredFees: '必填费用项',
    noRequiredFees: '暂无必填费用项',
    noConfig: '无配置内容',
    suppliers: '关联供应商',
    noSuppliers: '暂无关联供应商',
    fieldCount: '{count} 个',
    supplierCount: '{count} 家',
    labels: {
      templateNo: '模板编号',
      templateName: '模板名称',
      businessType: '业务类型',
      templateTypes: '模板配置',
      status: '状态',
      fieldCount: '字段数',
      supplierCount: '关联供应商数',
      createdAt: '创建时间',
      updatedAt: '更新时间'
    },
    columns: {
      fieldCode: '字段标识',
      fieldName: '字段名称',
      fieldType: '字段类型',
      locked: '锁定状态',
      sortOrder: '排序号',
      options: '选项值'
    },
    notFound: '未找到该模板'
  },
  quotationList: {
    title: '供应商报价列表',
    supplier: '供应商',
    supplierPlaceholder: '请输入',
    templateType: '模板类型',
    submitted: '已提交',
    abandoned: '已放弃',
    viewDetail: '查看详情',
    columns: {
      quotationNo: '报价编号',
      templateName: '模板名称',
      status: '状态',
      submittedAt: '提交时间',
      actions: '操作'
    }
  },
  quotationDetail: {
    back: '返回列表',
    title: '报价详情',
    basicInfo: '基本信息',
    quotationNo: '报价编号',
    supplier: '供应商',
    templateName: '模板名称',
    templateType: '模板类型',
    status: '状态',
    submitted: '已提交',
    abandoned: '已放弃',
    submittedAt: '提交时间',
    content: '报价内容',
    empty: '暂无报价数据'
  },
  supplierH5: {
    title: '供应商报价',
    loaded: '报价模板已加载',
    templateLabel: '模板：{templateName}',
    supplierSuffix: '· {supplierName}',
    fieldsTitle: '报价字段',
    pleaseInput: '请输入{fieldName}',
    pleaseSelect: '请选择{fieldName}',
    pleaseFill: '请填写{fieldName}',
    submit: '提交报价',
    saveDraft: '保存草稿',
    loadFailed: '加载失败',
    loadFailedDesc: '无法加载报价模板，请检查链接是否有效',
    reload: '重新加载',
    linkInvalid: '报价链接无效或已失效',
    submitted: '报价已提交',
    submitFailed: '提交失败',
    draftSaved: '草稿已保存',
    saveFailed: '保存失败'
  },
  fieldConfigurator: {
    selectedFields: '已选字段',
    fieldConfig: '字段配置',
    fieldCount: '{count} 个字段',
    sort: '排序',
    fieldName: '字段名称',
    required: '是否必填',
    sharedFields: '公共字段',
    locked: '锁定',
    switchOptional: '切换为选填',
    switchRequired: '切换为必填',
    requiredLabel: '必填',
    optionalLabel: '选填',
    switchHidden: '切换为隐藏',
    switchVisible: '切换为显示',
    requiredFees: '必填费用项',
    feeCount: '{count} 项',
    feePlaceholder: '搜索并选择费用项',
    feeTip: '从费用管理基础数据中选择，保存费用ID',
    empty: '暂无字段'
  },
  association: {
    title: '供应商关联 — {templateName}',
    searchPlaceholder: '搜索供应商名称...',
    added: '已添加',
    add: '添加',
    notFound: '未找到供应商',
    noAvailable: '暂无可选供应商',
    associatedCount: '已关联供应商（{count} 家）',
    noneAssociated: '暂未关联供应商',
    unbindConfirm: '确认解除此供应商关联？',
    templateIncomplete: '模板信息不完整',
    standardNoBind: '标准模板无需手动关联供应商',
    saved: '关联已保存'
  },
  preview: {
    pleaseInput: '请输入{fieldName}',
    pleaseSelect: '请选择',
    selectDate: '选择日期',
    pleaseEnter: '请输入',
    startDate: '开始日期',
    endDate: '结束日期',
    searchSelect: '搜索选择',
    searchOrInput: '搜索或输入',
    weekdays: ['一', '二', '三', '四', '五', '六', '日'],
    currency: '币种',
    amount: '金额',
    readonly: '只读',
    noSubFields: '暂无子字段'
  },
  api: {
    catalogEmpty: '字段目录为空，请先初始化',
    noTemplateTypes: '模板未配置业务类型，无法关联供应商'
  }
}
